import "./TermsConditions.module.css";
import Header from "@/reusable_sections/Header";
import Terms from "./sections/Terms";
export default function TermsConditionsPage() {
  return <div>
      <Header />
      <Terms />
    </div>;
}